/**
 * Границы «вменяемого» года для дат из пользовательского ввода: дедлайн
 * заявки, дата контакта «Контроля КП», периоды отчётов.
 *
 * Нативный <input type="date"> пропускает год из 5–6 цифр (62026): JS такую
 * дату принимает, а Prisma падала на расширенном ISO «+062026-…» (инцидент
 * 27.08.2026). Раньше границы 2000/2100 были вписаны числами в семи местах api
 * и web; это единая точка правды (№137 техдолга, пакет 5).
 */
export const USER_DATE_YEAR_MIN = 2000
export const USER_DATE_YEAR_MAX = 2100

/** Для атрибутов min/max у <input type="date">. */
export const USER_DATE_INPUT_MIN = `${USER_DATE_YEAR_MIN}-01-01`
export const USER_DATE_INPUT_MAX = `${USER_DATE_YEAR_MAX}-12-31`

/** «2000–2100» — для текстов ошибок. */
export const USER_DATE_YEAR_RANGE_LABEL = `${USER_DATE_YEAR_MIN}–${USER_DATE_YEAR_MAX}`
